.select {
  position: relative;
  display: inline-block;
  min-width: 0;
}
.fullWidth {
  display: block;
}
.trigger {
  display: inline-flex;
  align-items: center;
  gap: var(--hs-spacing-2);
  width: 100%;
  border: 1px solid var(--hs-color-border-default);
  border-radius: var(--hs-radius-full);
  background: var(--hs-color-bg-surface);
  color: var(--hs-color-text-primary);
  font: var(--hs-type-label);
  letter-spacing: var(--hs-label-ls);
  white-space: nowrap;
  cursor: pointer;
  transition:
    border-color 120ms ease,
    box-shadow 120ms ease;
}
.sm {
  height: 36px;
  padding: 0 var(--hs-spacing-3);
}
.md {
  height: var(--hs-field-height);
  padding: 0 var(--hs-spacing-4);
}
.trigger:hover:not(:disabled) {
  border-color: var(--hs-color-border-strong);
}
.trigger:focus-visible,
.trigger[aria-expanded='true'] {
  outline: none;
  border-color: var(--hs-color-primary-default);
  box-shadow: var(--hs-focus-lavender);
}
.trigger:disabled {
  background: var(--hs-color-bg-muted);
  opacity: 0.6;
  cursor: not-allowed;
}
.lead {
  flex: none;
  color: var(--hs-color-text-secondary);
}
.value {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
}
.chevron {
  flex: none;
  color: var(--hs-color-text-secondary);
  transition: transform 120ms ease;
}
.turned {
  transform: rotate(180deg);
}

.list {
  position: absolute;
  top: calc(100% + var(--hs-spacing-2));
  z-index: 40;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 100%;
  max-height: 280px;
  margin: 0;
  padding: var(--hs-spacing-1);
  overflow-y: auto;
  border: 1px solid var(--hs-color-border-default);
  border-radius: var(--hs-radius-md);
  background: var(--hs-color-bg-surface);
  box-shadow: var(--hs-shadow-xl);
  list-style: none;
}
.start {
  left: 0;
}
.end {
  right: 0;
}
.option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--hs-spacing-4);
  padding: var(--hs-spacing-2) var(--hs-spacing-3);
  border-radius: var(--hs-radius-sm);
  color: var(--hs-color-text-primary);
  font: var(--hs-type-body-s);
  white-space: nowrap;
  cursor: pointer;
}
.active {
  background: var(--hs-color-bg-sunken);
}
.option[aria-selected='true'] {
  color: var(--hs-color-primary-on-container);
  font-weight: 700;
}
.optionLabel {
  min-width: 0;
}
.check {
  flex: none;
  color: var(--hs-color-primary-default);
}
